Vue.component('chat-video', {
	props: ['options'],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInLeft" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<div id="video" :class="{ \'escalation\': hasEscalation }">' +
		'<button v-if="isAllowClose" class="close-media" @click="closeMedia"><i class="material-icons">&#xE5C9;</i></button>' +
		'<div v-if="options.isChatOnlyVideo">' +
		'<img :src="getImgAgent()"  :class="{ \'trasfering\': inTransfer }" class="img-agent img-responsive"  onerror="svgOnError()">' +
		'<p v-if="getAgentName()" class="agent-name" :class="{ \'trasfering\': inTransfer }" :title="getAgentName()" >{{ getAgentName() }}</p>' +
		'<p class="repobtn"><button @click="openRepo" id="repo" v-if="isRepoActive" rel="tooltip" data-placement="left"><i class="material-icons videonly">folder</i></button></p>'+
		'<span class="badge badge-repository badge-pill badge-primary" v-if="showRepoBadge">{{counterRepoBadge}}</span>'+
		'</div>' + 
		'<div id="mediabox" class="mediabox">' +
                '<div id="file_screenshot" class="hidden">' +
                '<canvas id="mediabox_canvas"></canvas>' +
                '<img id="file_screen" alt="The screen capture will appear in this box."></div>' +
		'</div>' +
		'</transition>',
	data: function () {
		return {
			isActive: false,
			isf2s: true,
			hasEscalation: false,
			msg: '',
			isAllowClose: false,
			inTransfer: false,
			agentName: '',
			isRepoActive: false,
			repositoryItems: [],
			showRepoBadge: false,
			counterRepoBadge: '',
			lastCounterRepoBadge: 0,
		}
	},
	created: function() {
	
	},
	mounted: function () {
		var that = this;

		

		bus.$on('onVideoEscalation', function (val) {
			that.contentShow(val);
			that.setEscalation(val)
		});

		bus.$on('isRingingEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isQueuedEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isRunningEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isF2F', function (val) {
			that.isf2f = val;
		});

		//CUSTOMCOMAND
		this.$parent.$on("onAgentSendScreenShot", function(param){
			that.doScreenShot();
		});

		bus.$on('addRepoItem', function(repo) {
			that.showRepoButton(repo);
		 });

		this.$parent.$on('onVideoEscalation', function (val) {
			that.contentShow(val);
			that.setEscalation(val)
		});

		this.$parent.$on('onVideoStreamSwitched', function(evt) {
			that.switchVideoStream(evt);
		});

		this.$parent.$on('onVideoShow', function (val) {
			that.contentShow(val);
		});

		this.$parent.$on('onRecording', function (val) {
			that.startRecording(val);
		});

		this.$parent.$on('isRingingEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isQueuedEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isRunningEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isF2F', function (val) {
			that.isf2f = val;
		});

	},
	methods: {
		svgOnError:function(){
			console.log('Fail to load svg chat video');
		},
		contentShow: function (val) {
			this.isActive = val;
		},

		setEscalation: function (val) {
			this.hasEscalation = val;
		},
		closeMedia: function () {
			bus.$emit("onEscalation", false);
			this.contentShow(false);

		},
		getAgentName: function () {
			// if(this.agentName != "") {
			// 	return this.agentName
			// } else {
			// 	return this.options.internal.agentDisplayName
			// }
			if (!this.isf2s) {
				return this.agentName;
			} else {
				return this.options.internal.agentDisplayName;
			}
		},
		getImgAgent: function () {
			if (this.options.isVirtualAgent == true) {
				return this.options.imgVirtualAgent;
			}
			else {
				return this.options.imgAgent;
			}
		},
		startRecording: function (val) {
			if (val == true) {
				Vue.nextTick(function () {
					if ($('#eu_media_remote').length > 0) {
						$('<div id="rec_blink" class="blink"><i class="material-icons pull-left">&#xE3A6;</i><span>REC</span></div>').appendTo('#eu_media_remote');
					} else if ($('#eu_media_wrapper').length > 0) {
						$('<div id="rec_blink" class="blink"><i class="material-icons pull-left">&#xE3A6;</i><span>REC</span></div>').appendTo('#eu_media_wrapper');
					}
				})
			} else {
				Vue.nextTick(function () {
					$('#rec_blink').remove();
				})
			}

		},
		showRepoButton:function(repo) {
			this.repositoryItems = repo;
			this.isRepoActive = true;
			this.showRepoBadge = true;
			this.counterRepoBadge = repo.length - this.lastCounterRepoBadge;
			

		},
		openRepo:function(){
			//this.hideTooltip();
			this.lastCounterRepoBadge = this.repositoryItems.length;
			this.counterRepoBadge = '';
			bus.$emit("onOpenRepo",true);
		},

		switchVideoStream: function(evt) {
		    bus.$emit("log-event", { level: "INFO", message: "Video - Switching main stream to " + evt.status });

		    var objs = { customer: { container: 'eu_media_local', object: 'eu_media_local_obj' }, agent: { container: 'eu_media_remote', object: 'eu_media_remote_obj' } };

		    Object.keys(objs).forEach(function(key) {
		        if (key == evt.status) {
		            $('#' + objs[key].container).removeClass('previewed');
		            $('#' + objs[key].object).removeClass('previewed');
		        } else {
		            $('#' + objs[key].container).addClass('previewed');
		            $('#' + objs[key].object).addClass('previewed');
		        }
		    });
		},

		doScreenShot: function() {
			console.log("Do screenshot");
			try {
				var video = document.getElementById('eu_media_local_obj');
				console.log("copy from width:" + video.offsetWidth + " - height:" + video.offsetHeight);

				if (video.offsetWidth > 0 && video.offsetHeight > 0) {
					this.$parent.appendSystemMsg('info', this.$parent.labelLang.takeCustomerPhotograph);

					// Copying the image in a temporary canvas
					//var originalWidth  = video.offsetWidth;
					//var originalHeight = video.offsetHeight;

					var expectedWidth  = 640;
					var expectedHeight = 480;
					//video.style.width  = expectedWidth; // '640px';
					//video.style.height = expectedHeight; // '320px';
					//video.style.width  = '640px';
					//video.style.height = '480px';
					//console.log("copy change width:" + video.offsetWidth + " - height:" + video.offsetHeight);

					console.log("copy to width:" + expectedWidth + " - height:" + expectedHeight);
					var canvas = document.getElementById('mediabox_canvas');
					canvas.width  = expectedWidth;
					canvas.height = expectedHeight;
					var context = canvas.getContext('2d');
					context.drawImage(video, 0, 0, expectedWidth, expectedHeight);

					//video.style.width  = originalWidth;
					//video.style.height = originalHeight;

					var img_result = canvas.toDataURL('image/png');
					console.log("screenshot size:"+img_result.length);
					this.sendImgScreenShot(img_result);
				}
			} catch(err) {
				console.log("Video- doScreenShot - error "+err);
			}
		},

		sendImgScreenShot: function(file_img) {
			try {
				var image = document.getElementById('file_screen');
				image.setAttribute('src',file_img);
				console.log("image header: "+file_img.substring(1,40));

				this.options.internal.bridge.sendFile('file_screen');
			} catch(err) {
				console.log("sendImgScreenShot() => Error "+err);
			}
		}
	}
})
